var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYouTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#103265"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2738 9.84782C25.0267 8.92987 24.3029 8.20611 23.385 7.95897C21.7079 7.5 14.9999 7.5 14.9999 7.5C14.9999 7.5 8.29185 7.5 6.61483 7.94132C5.71454 8.18846 4.97313 8.92987 4.72599 9.84782C4.28467 11.5248 4.28467 15.0024 4.28467 15.0024C4.28467 15.0024 4.28467 18.4977 4.72599 20.157C4.97313 21.075 5.69689 21.7987 6.61483 22.0459C8.3095 22.5049 14.9999 22.5049 14.9999 22.5049C14.9999 22.5049 21.7079 22.5049 23.385 22.0635C24.3029 21.8164 25.0267 21.0926 25.2738 20.1747C25.7151 18.4977 25.7151 15.0201 25.7151 15.0201C25.7151 15.0201 25.7328 11.5248 25.2738 9.84782Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8639 18.2152L18.4422 15.0024L12.8639 11.7896V18.2152Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTube);
export default __webpack_public_path__ + "static/media/youTube.25049e6e6a378ec8da979cfaea865102.svg";
export { ForwardRef as ReactComponent };